import { makeStyles } from '@material-ui/core/styles';

// const drawerWidth = 0;

export default makeStyles((theme) => ({
  title: {
    // flexGrow: 1,
    alignItems: 'center',
    display: 'flex',
    textDecoration: 'none',
    color: 'inherit',
    width: 'auto',
  },

  hide: {
    [theme.breakpoints.down('901')]: {
      display: 'none'
    }
  },

  span: {
    font: 'Roboto, sans-serif',
    fontSize: '30px',
    fontWeight: '600',
    backgroundImage: 'linear-gradient(315deg, #f7b42c 0%, #fc575e 74%)',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
    [theme.breakpoints.down('768')]: {
      fontSize: '25px',
      fontWeight: '400',
    }

  },

  image: {
    height: '40px',
    borderRadius: '50%',
    [theme.breakpoints.down('768')]: {
      height: '30px',
    }
  },
}));